import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageRoutes } from "../constants/routes";
import { appActions } from "../ducks/app";
import { campaignActions, campaignSelectors } from "../ducks/campaign";
import { couponActions, couponSelectors } from "../ducks/coupon";
import { menuActions } from "../ducks/menu";
import { useNavigation } from "./useNavigation";

export const useHeader = (requiredLogout?: boolean) => {
  const dispatch = useDispatch();
  const { navigateToPage, navigateToTopPage } = useNavigation();
  const activeCampaigns = useSelector(campaignSelectors.sortedActiveCampaigns);
  const appliedCoupons = useSelector(couponSelectors.appliedCoupons);

  const handleLogoClick = useCallback(() => {
    if (activeCampaigns?.length > 0)
      return navigateToPage(PageRoutes.CAMPAIGN_SELECTION);
    dispatch(
      campaignActions.fetchActiveCampaign.started({
        onSuccess(data) {
          // 早割または在庫キャンペーンがあれば選択画面へ
          if (data.campaigns?.length > 0)
            navigateToPage(PageRoutes.CAMPAIGN_SELECTION);
          else navigateToTopPage();
        },
        onError() {
          navigateToTopPage();
        },
      }),
    );
  }, [activeCampaigns]);

  const handleLanguageSelectClick = useCallback(() => {
    dispatch(appActions.showLanguageSelectModal());
  }, []);

  const handleUserGuideClick = useCallback(() => {
    navigateToPage(PageRoutes.USER_GUIDE);
  }, []);

  const handleLoginClick = useCallback(() => {
    const redirectPath = requiredLogout
      ? PageRoutes.HOME
      : (window.location.hash.substring(1) ?? undefined);
    navigateToPage(PageRoutes.LOGIN, true, { redirectPath });
  }, [requiredLogout]);

  const handleMyPageClick = useCallback(() => {
    navigateToPage(PageRoutes.MY_PAGE);
  }, []);

  const handleCancelAppCoupon = useCallback(() => {
    dispatch(
      appActions.showModal.started({
        title: "アプリクーポンを削除してもよろしいですか？",
        subTitle:
          "※アプリ連携クーポンを削除すると当該クーポンは利用できなくなります",
        nextButtonLabel: "はい",
        handleNext: () => {
          dispatch(
            // !TBC: Decide Remove All Or NOT
            couponActions.removeAllAppCoupons.started({
              onSuccess: (couponCodes) =>
                couponCodes.forEach((couponCode) => {
                  const couponToRemove = appliedCoupons
                    ?.filter((coupon) => coupon.code === couponCode)
                    .map((coupon) => coupon.uuid);
                  if (couponToRemove) {
                    dispatch(
                      menuActions.removeMenuFromCartByCouponUuids.started({
                        couponUuids: couponToRemove,
                      }),
                    );
                  }
                }),
            }),
          );

          dispatch(appActions.closeModal());
        },
        closeButtonLabel: "閉じる",
        handleClose: () => dispatch(appActions.closeModal()),
      }),
    );
  }, [appliedCoupons]);

  const handleCancelReorder = useCallback(() => {
    dispatch(menuActions.cancelReorder());
    navigateToPage(PageRoutes.ORDER_HISTORY);
  }, []);

  return {
    handleLogoClick,
    handleLanguageSelectClick,
    handleUserGuideClick,
    handleLoginClick,
    handleMyPageClick,
    handleCancelAppCoupon,
    handleCancelReorder,
  };
};
